import { Popover } from '@headlessui/react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

// TODO: Use our radix popover impl instead of headlessui
export const IconPopover = ({
  children,
  textPosition = 'absolute w-[283px]',
}: {
  children: React.ReactNode;
  textPosition?: any;
}) => {
  return (
    <Popover className="relative h-5 w-5">
      <Popover.Button>
        <QuestionMarkCircleIcon className="h-5 w-5 text-primary-700" />
      </Popover.Button>
      <Popover.Panel
        className={`${textPosition} z-20 border border-gray-300 bg-white p-2 text-sm text-gray-500 shadow`}
      >
        {children}
      </Popover.Panel>
    </Popover>
  );
};
